module.exports = __webpack_public_path__ + "img/43.97a83d88.jpg";